export function haversineMeters(a: [number, number], b: [number, number]): number {
  const R = 6_371_000
  const toRad = (v: number) => (v * Math.PI) / 180
  const dLat = toRad(b[1] - a[1])
  const dLon = toRad(b[0] - a[0])
  const lat1 = toRad(a[1])
  const lat2 = toRad(b[1])
  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x))
}

export function cumulativeDistances(coords: [number, number][]): number[] {
  const out = [0]
  for (let i = 1; i < coords.length; i++) {
    out.push(out[i - 1] + haversineMeters(coords[i - 1], coords[i]))
  }
  return out
}

export function interpolateAlongLine(
  coords: [number, number][],
  cumDists: number[],
  t: number,
): [number, number] {
  const total = cumDists[cumDists.length - 1]
  const target = Math.max(0, Math.min(total, t * total))
  let lo = 0
  let hi = cumDists.length - 1
  while (lo < hi - 1) {
    const mid = (lo + hi) >> 1
    if (cumDists[mid] <= target) lo = mid
    else hi = mid
  }
  const segLen = cumDists[hi] - cumDists[lo]
  if (segLen === 0) return coords[lo]
  const segT = (target - cumDists[lo]) / segLen
  return [
    coords[lo][0] + segT * (coords[hi][0] - coords[lo][0]),
    coords[lo][1] + segT * (coords[hi][1] - coords[lo][1]),
  ]
}

export function bearingBetween(a: [number, number], b: [number, number]): number {
  const toRad = (v: number) => (v * Math.PI) / 180
  const dLon = toRad(b[0] - a[0])
  const lat1 = toRad(a[1])
  const lat2 = toRad(b[1])
  const y = Math.sin(dLon) * Math.cos(lat2)
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon)
  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360
}
